import React from "react";
import Icon from "components/AppIcon";
import QuestionOverviewPanel from "./QuestionOverviewPanel";

const MobileOverviewDrawer = ({ isOpen, onClose, totalQuestions, answers, currentIndex, onNavigate }) => {
  if (!isOpen) return null;

  const handleNavigate = (idx) => {
    onNavigate(idx);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-40 flex items-end md:hidden"
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
      onClick={onClose}
    >
      <div
        className="w-full rounded-t-2xl p-5 max-h-[70vh] overflow-y-auto"
        style={{ backgroundColor: "var(--color-card)" }}
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-base" style={{ color: "var(--color-text-primary)" }}>
            Navigation des questions
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ backgroundColor: "var(--color-muted)" }}
          >
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>
        <QuestionOverviewPanel
          totalQuestions={totalQuestions}
          answers={answers}
          currentIndex={currentIndex}
          onNavigate={handleNavigate}
        />
      </div>
    </div>
  );
};

export default MobileOverviewDrawer;